import { Observable } from 'rxjs';

import { FormSelectOption, MultiFormSelectOptions } from '@stylehaven/components';

export function toFormSelectOption(value: string, label?: string): FormSelectOption {
    return {
        label: label || value,
        value
    };
}

export function multiFormSelectOptionWrapper<T>(
    formSelectOptions: FormSelectOption<T>[] | undefined
): MultiFormSelectOptions<T> {
    return { isLiveData: false, options: formSelectOptions || [] };
}

export type AutocompleteFunction = (value: string) => Observable<MultiFormSelectOptions>;
